import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AlertService } from "src/app/services/alert.service";
import { DobleAutenticacionService } from "src/app/services/doble-autenticacion.service";
import { ParametrosService } from "src/app/services/parametros.service";
import { RouterService } from "src/app/services/router.service";
import { SweetAlertService } from "src/app/services/sweet-alert.service";
import { UserService } from "src/app/services/user.service";
import { UtmTrackingService } from "src/app/services/utm-tracking.service";

@Component({
    selector: 'app-doble-autenticacion',
    templateUrl: './doble-autenticacion.component.html',
    styleUrls: ['./doble-autenticacion.component.scss'],
    standalone: false
})
export class DobleAutenticacionComponent implements OnInit{
    codigo: any = "";
    parametros: any;
    constructor(
        private _parametro: ParametrosService,
        private router: Router,
        private _alert: AlertService,
        private _router: RouterService,
        private _dobleAutenticacion: DobleAutenticacionService,
        private _user: UserService,
        private _sweetAlert:SweetAlertService,
        private readonly utmTracking: UtmTrackingService
    ){}

    ngOnInit(){
        this.parametros = this._dobleAutenticacion.getParametros();
    }

    verificarCod(){
        const body = {
            token: this.parametros.token,
            codigo: this.codigo.replaceAll(' ',''),
        }
        this._parametro.validateOtp(body)
            .subscribe((response : any) => {
                if(response.exitoso === 'true'){
                    this._user.saveUser({
                      idSolicitud: "",
                      ...this.parametros.data,
                      numeroDocumento:
                        this.parametros?.data?.numeroDocumento ||
                        this.parametros?.numeroDocumento,
                    });
                    this.utmTracking.sincronizarTrasIdentificar({
                      correoElectronico: this.parametros?.data?.correoElectronico,
                      numeroDocumento:
                        this.parametros?.data?.numeroDocumento ||
                        this.parametros?.numeroDocumento,
                      razonSocial:
                        this.parametros?.data?.nombre ||
                        this.parametros?.data?.razonSocial,
                    });
                    this.router.navigateByUrl(`${this.parametros.path}/home`);
                }else{
                    this._sweetAlert.errorModal("Error!",true,'Código invalido');
                }
            });
    }

    sendOtp(){
        this._parametro.sendOtp(this.parametros.email)
            .subscribe((response : any) => {
                if(response.exitoso === 'true'){
                    this._sweetAlert.successModal('Código enviado');
                }else{
                    this._sweetAlert.errorModal("Error!",true,response.error);
                }
            })
    }

    back(){
        this._router.goBack();
    }

    validateNumber(event: any) {
        const pattern = /[0-9]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
          event.preventDefault();
        }
      }
}
